import { createContext } from 'react';

export const NO_CURRENT_CASE_ID_PROVIDER = Symbol('no-current-case-id-provider');

// The current case id, computed once by `CurrentCaseProvider` instead of in every `useCurrentCaseId` caller.
export const CurrentCaseIdContext = createContext<
  Nullable<string> | typeof NO_CURRENT_CASE_ID_PROVIDER
>(NO_CURRENT_CASE_ID_PROVIDER);
